const shared = {
	maxAppWidth: 1440,
	header: {
		language: {
			default: 'en',
			options: [
				{ label: 'English', value: 'en' },
				{ label: 'Arabic', value: 'ar' }
			]
		},
		content: {
			logout: 'Internet Banking'
		},
		menu: {
			primary: [
				{
					name: 'Internet Banking',
					to: process.env.REACT_APP_GSP_DASHBOARD_PAGE_LIN,
					mobile: true,
					isActive: false
				}
			]
		}
	},
	showAll: {
		title: 'showAll'
	}
};

const figure1 = {

	content: [
		{
			imgName: 'ESGEnhanced',
			textHeader: 'ESG.figure1_Enhanced',
			textContent1_1: 'ESG.figure1_Enhanced_content_1_1',
			textContent1_2: 'ESG.figure1_Enhanced_content_1_2',
			textContent1_2_1: 'ESG.figure1_Enhanced_content_1_2_1',
			textContent1: 'ESG.figure1_Enhanced_content_1',
			examples: 'ESG.figure1_Examples',
			textContent2: 'ESG.figure1_Enhanced_content_2'
		},
		{
			imgName: 'Thematic',
			textHeader: 'ESG.figure1_Thematic',
			textContent1_1: 'ESG.figure1_Thematic_content_1_1',
			textContent1_2: 'ESG.figure1_Thematic_content_1_2',
			textContent1_2_2:'ESG.figure1_Thematic_content_1_2_2',
			examples: 'ESG.figure1_Examples',
			textContent2: 'ESG.figure1_Thematic_content_2'
		},
		{
			imgName: 'Impact',
			textHeader: 'ESG.figure1_Impact',
			textContent1_1: 'ESG.figure1_Impact_content_1_1',
			textContent1_2: 'ESG.figure1_Impact_content_1_2',
			textContent1_3: 'ESG.figure1_Impact_content_1_3',
			examples: 'ESG.figure1_Examples',
			textContent2: 'ESG.figure1_Impact_content_2'
		}
	]
};

const quesNum = {
	quesNum1 : '1',
	quesNum2 : '2',
	quesNum3 : '3',
	quesNum3_1 : '3-1'
};

const ansNum = {
	ansNum0 : '0',
	ansNum1 : '1',
	ansNum2 : '2',
	ansNum3 : '3',
	ansNum4 : '4'
};

const currentQuesNum = {
	curQuesNum1 : 1,
	curQuesNum2 : 2,
	curQuesNum3 : 3
};

export { shared, figure1, quesNum, ansNum, currentQuesNum };
